<script>
  import { onMount, getContext } from 'svelte'
  import {
    neptuneQuestions,
    neptuneBusinessReviews,
    neptuneProductReviews,
    getNeptuneQuestions,
    getNeptuneProductReviews,
    getNeptuneBusinessReviews
  } from '../../stores'
  import ReviewAndQuestion from './ReviewAndQuestion.svelte'
  import ReviewForm from '../../components/ReviewForm.svelte'
  import QuestionForm from '../../components/QuestionForm.svelte'
  import configModule from '../../config'
  import { isObjectEmpty } from '../../utils'

  let isResponseAvailable

  export let settings
  export let name

  let productReviewsResponse
  let questionsResponse
  let siteReviewsResponse
  let limit
  let isMedia

  onMount(async () => {
    if (settings) {
      const config = configModule()
      try {
        const businessId = config.aid
        const clientId = config.apiKey
        limit = settings.widget_settings.neptune.reviews_per_page
        isMedia =
          settings.widget_settings.general_settings.show_media_reviews_only

        const tabsToShow = settings.widget_settings.neptune.tabs_to_show
        const showQnA =
          settings.widget_settings.neptune.show_questions_and_answers
        if (name === 'ReviewAndQuestion') {
          ;[
            productReviewsResponse,
            questionsResponse,
            siteReviewsResponse
          ] = await Promise.all([
            tabsToShow.includes('PRODUCT') &&
            (!isObjectEmpty($neptuneProductReviews)
              ? $neptuneProductReviews
              : getNeptuneProductReviews({
                  businessId,
                  clientId,
                  limit,
                  isBusiness: false,
                  ...(isMedia && { isMedia })
                })),
            showQnA && (!isObjectEmpty($neptuneQuestions)
              ? $neptuneQuestions
              : getNeptuneQuestions({
                  businessId,
                  clientId,
                  limit
                })),
            tabsToShow.includes('BUSINESS') &&
            (!isObjectEmpty($neptuneBusinessReviews)
              ? $neptuneBusinessReviews
              : getNeptuneBusinessReviews({
                  businessId,
                  clientId,
                  limit,
                  isBusiness: true,
                  ...(isMedia && { isMedia })
                }))
          ])
          isResponseAvailable = true
        }
      } finally {
        config.isPreview &&
          window.dispatchEvent(new Event(config.previewLoadedEvent))
      }
    }
  })

  const { open, close } = getContext('kudobuzz-modal')

  const showModal = () => {
    if (name && name === 'ReviewAndQuestion') {
      open(
        ReviewAndQuestion,
        {
          settings,
          contentData: {
            ...(productReviewsResponse && {
              productReviews: productReviewsResponse
            }),
            ...(questionsResponse && { questions: questionsResponse }),
            ...(siteReviewsResponse && { siteReviews: siteReviewsResponse })
          }
        },
        { isNeptuneModal: true }
      )
    } else if (name && name === 'ReviewForm') {
      open(
        ReviewForm,
        { settings, widgetType: 'neptune', close },
        { isNeptuneModal: true }
      )
    } else if (name && name === 'QuestionForm') {
      open(
        QuestionForm,
        { settings, close, widgetType: 'neptune' },
        { isNeptuneModal: true }
      )
    }
  }
</script>

<style>
  section {
    cursor: pointer;
  }
</style>

{#if isResponseAvailable || (name && name !== 'ReviewAndQuestion')}
  <section on:click={showModal}>
    <slot />
  </section>
{/if}
